import React from "react";
import Tooltip from "../../../../../components/common/Tooltip/Tooltip";
import {
  PaddingTopIcon,
  PaddingRightIcon,
  PaddingBottomIcon,
  PaddingLeftIcon,
} from "../../../../../icons";
import {
  clampPaddingSide,
  PADDING_UNIT,
} from "../../../../../utils/canvasPaddingLayout";
import "./PaddingPrepControls.css";

const directionIcons = {
  top: <PaddingTopIcon className="padding-prep-pill__icon" />,
  right: <PaddingRightIcon className="padding-prep-pill__icon" />,
  bottom: <PaddingBottomIcon className="padding-prep-pill__icon" />,
  left: <PaddingLeftIcon className="padding-prep-pill__icon" />,
};

const tooltipText = {
  top: "Top padding\nAdds space above the image",
  right: "Right padding\nAdds space to the right of the image",
  bottom: "Bottom padding\nAdds space below the image",
  left: "Left padding\nAdds space to the left of the image",
};

const PaddingPrepPill = ({
  value,
  onChange,
  direction,
  unit = PADDING_UNIT.PERCENT,
  disabled = false,
}) => {
  const maxDigits = unit === PADDING_UNIT.PX ? 4 : 2;

  const handleChange = (e) => {
    const val = e.target.value.replace(/[^0-9]/g, "").slice(0, maxDigits);
    if (val === "") {
      onChange(0);
    } else {
      onChange(clampPaddingSide(Number(val), unit));
    }
  };

  const unitLabel = unit === PADDING_UNIT.PX ? "px" : "%";

  return (
    <div className="padding-prep-pill">
      <Tooltip content={tooltipText[direction]} position="top">
        <div className="padding-prep-pill__icon-wrap">
          {directionIcons[direction]}
        </div>
      </Tooltip>
      <input
        type="text"
        inputMode="numeric"
        value={value}
        onChange={handleChange}
        className="padding-prep-pill__input"
        aria-label={`${direction} padding`}
        disabled={disabled}
      />
      <span className="padding-prep-pill__unit">{unitLabel}</span>
    </div>
  );
};

export default PaddingPrepPill;
